import {entity} from "../../components/ListComponentEntity";
import {NavLink} from "react-router-dom";
import React from "react";
import {NewList} from "../../components/NewList/NewList";

export const ListAccountNew = (props) => {
    return (
        <NewList
            { ...props }
            entity={'account'}
            entity_type={3}
            requiredFields={'id,name,type_id,work_phone,mobile_phone,email'}
            requiredExpand={'type'}
            deleteToShowColumn={'id,name,type,work_phone,mobile_phone,email'}
            additionalFieldsExists={true}
            isFilterExists={true}
            filterFields={entity.account.fArr}
            singleSearch={entity.account.fArr[0]}
            headingColumns={['Название', 'Статус', 'Почта', 'Телефоны']}
            analytics={'/account/report/'}
            RenderColumn={(item, setModalType, setModalData) => (
                <>
                    <td>
                        <NavLink to={`/account/${item.id}`}  className={'nowrap-list-column'}>{item.name}</NavLink>
                    </td>
                    <td>
                        {item.type && <span className="label-st" style={{ backgroundColor: 'rgb(255, 193, 100)' }}>{item.type.value}</span>}
                    </td>
                    <td>
                        <div>{item.email}</div>
                    </td>
                    <td>
                        <div>{item.mobile_phone}</div>
                        <div>{item.work_phone}</div>
                    </td>
                </>
            )}
            createButtonRender={(setModalType) => <button onClick={() => setModalType('account')} className="open-modal-button btni">Новый контрагент</button>}
            rightNavbarConfig={{
                export: true,
                additionalFields: '/fieldsettings/3',
                columns: true,
                import: '/import/account'
            }}
            massDoConfig={{ deleteAll: `/ajax/invoice/delete-all` }}
            contextNav={{ edit: true, task: true, print: false, delete: true }}
            sort={entity.account.fArr.filter(el => el.sort)}
        />
    )
}